module.exports = __webpack_public_path__ + "static/media/cooking-salon-ad1.234df153.png";